import genevaAiBanner from '@/assets/geneva-ai-banner.png';
import unAiBanner from '@/assets/un-ai-banner.png';
import unBanner from '@/assets/un-banner.png';

export interface FootprintItem {
  title: string;
  description: string;
  link: string;
  image: string;
}

export const FOOTPRINTS: FootprintItem[] = [
  {
    title: 'UN & AI Footprint',
    description: 'How visible are UN and international organizations when searching for AI-related topics across 50 cities worldwide?',
    link: '/un-ai-home',
    image: unAiBanner,
  },
  {
    title: 'UN Footprint',
    description: 'How visible are UN online resources when searching for 500+ policy topics from across 50 cities worldwide?',
    link: '/un-home',
    image: unBanner,
  },
  {
    title: 'Geneva AI Footprint',
    description: 'How relevant are Geneva’s resources when it comes to covering 234 AI topics?',
    link: '/geneva-home',
    image: genevaAiBanner,
  },
  {
    title: 'Diplomatic Footprint',
    description: "How visible are Geneva's online resources when searching for 500 diplomatic topics from across 50 cities worldwide?",
    link: '/diplomatic-home',
    image: '/assets/image3.jpg',
  },
  {
    title: 'Tech Footprint',
    description: 'How relevant are Geneva’s actors on tech issues searched from 50 cities worldwide?',
    link: '/tech-home',
    image: '/assets/image2.jpg',
  },
  {
    title: 'Tech Footprint of Global Media',
    description: 'What is the relevance of the main media in covering AI and tech issues?',
    link: '/mediadigital-home',
    image: '/assets/mediadigital-banner.png',
  },
];
